/* eslint-disable no-loop-func */
import { VirtualType } from '../types';

import { getManifest } from './get-manifest';
import { makeModuleVirtualModule } from './make-virtual-module';

export const preloadHosts: {
  [key: string]: { css: string; js: string };
} = {};

let action: ((host: string) => void) | null = null;

export const PRELOAD = (function () {
  const p: { [key: string]: Promise<boolean> } = {};

  return {
    create(target: string) {
      p[target] = new Promise(resolve => {
        action = (host: string) => {
          if (host === target) {
            resolve(true);
          }
        };
      });
    },
    async wait(host: string) {
      return p[host];
    },
  };
})();

export async function preloader(
  host: string,
  virtualOption?: VirtualType,
  manifestPath?: string,
): Promise<void> {
  try {
    const virtual = {
      dom: false,
      window: true,
      windowApprovedFields: [
        'addEventListener',
        'removeEventListener',
        'localStorage',
        'sessionStorage',
      ],
      ...(virtualOption ?? {}),
    };

    PRELOAD.create(host);
    preloadHosts[host] = { css: '', js: '' };
    const manifest: any = await getManifest(host, host, manifestPath);
    const w = window as any;

    w.showcase_connected = 'connected';

    if (!w['showcase_modules']) {
      w['showcase_modules'] = {};
    }

    for (const key in manifest.files) {
      if (!key.match(/\.js|\.css/) || key.includes('.map')) {
        continue;
      }

      const url = `${manifestPath ?? host}${manifest.files[key]}`;
      if (key.match(/\.js/)) {
        // @ts-expect-error undefined
        preloadHosts[host].js = url;

        if (virtualOption) {
          makeModuleVirtualModule({ name: host, virtual }, url, () => {
            if (action) {
              action(host);
            }
          });
          continue;
        }

        const script = document.createElement('script');
        script.crossOrigin = '';
        script.src = url;
        script.onload = () => {
          if (action) {
            action(host);
          }
        };
        document.body.append(script);
      } else {
        // @ts-expect-error undefined
        preloadHosts[host].css = url;
      }
    }
  } catch (e) {
    throw new Error('Manifest or script loading error');
  }
}
